import React from 'react'
import { IconButton, Tooltip } from '@mui/material'

interface Props {
  label: string
  /** An outlined `@mui/icons-material` glyph, the set Campaigns and Audiences use for row actions. */
  icon: React.ReactNode
  onClick?: () => void
  href?: string
}

/** One of the card's footer actions: a bare glyph, named by its tooltip. */
export const CardIconButton = ({ label, icon, onClick, href }: Props) => (
  <Tooltip title={label}>
    {href ? (
      <IconButton
        size="small"
        color="primary"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${label} (opens in a new tab)`}
        onClick={e => e.stopPropagation()}
      >
        {icon}
      </IconButton>
    ) : (
      <IconButton
        size="small"
        color="primary"
        aria-label={label}
        onClick={e => {
          e.stopPropagation()
          onClick?.()
        }}
      >
        {icon}
      </IconButton>
    )}
  </Tooltip>
)
